<button
  *ngIf="permissions.hasPermission(permission.Create, activity) | async"
  class="floatFab"
  mat-fab
  color="primary"
  matTooltip="Add Users"
  i18n-matTooltip
  (click)="addUsers()"
>
  <mat-icon>add</mat-icon>
</button>
<button
  [matMenuTriggerFor]="menu"
  *ngIf="selection.hasValue()"
  class="floatFabSecondary"
  [matBadge]="selection.count"
  matBadgeColor="accent"
  mat-fab
  color="primary"
>
  <mat-icon>manage_accounts</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    (click)="sendSelected()"
    [disabled]="
      (permissions.hasPermission(permission.Update, activity) | async) === false
    "
  >
    <mat-icon color="primary">send</mat-icon>
    <span i18n>Send invitations</span>
  </button>
  <button
    mat-menu-item
    (click)="reissueSelected()"
    [disabled]="
      (permissions.hasPermission(permission.Delete, activity) | async) === false
    "
  >
    <mat-icon color="primary">reply_all</mat-icon>
    <span i18n>Reissue Invitations</span>
  </button>
  <button
    mat-menu-item
    (click)="deleteSelected()"
    [disabled]="
      (permissions.hasPermission(permission.Delete, activity) | async) === false
    "
  >
    <mat-icon color="warn">delete</mat-icon>
    <span i18n>Delete Invitations</span>
  </button>
</mat-menu>

<div fxFill fxLayout="column" fxLayoutGap="15px">
  <div class="table-wrapper">
    <table
      mat-table
      matSort
      matSortActive="username"
      matSortDirection="asc"
      [dataSource]="displayedRegistrations!"
    >
      <ng-container matColumnDef="select">
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          >
          </mat-checkbox>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="icon">
        <th mat-header-cell style="width: 15px" *matHeaderCellDef></th>
        <td
          mat-cell
          style="width: 15px"
          *matCellDef="let registration"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <mat-icon
            [color]="registration === highlightedRegistration ? 'primary' : ''"
            svgIcon="account-clock"
          ></mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          User Name
        </th>
        <td
          mat-cell
          *matCellDef="let registration"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <span>{{ registration.username }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Email
        </th>
        <td
          mat-cell
          *matCellDef="let registration"
          fxHide.lt-md
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <a [routerLink]="['/mfa-users', registration.email, 'pending']">{{
            registration.email
          }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="resourceName">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Resource Name
        </th>
        <td
          mat-cell
          *matCellDef="let registration"
          fxHide.lt-md
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <a
            [routerLink]="[
              '/protected-resources',
              registration.resourceId,
              'pending'
            ]"
            >{{ registration.resourceName }}</a
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="created">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Created
        </th>
        <td
          mat-cell
          fxHide.lt-md
          *matCellDef="let registration"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          {{ registration.created | date:'short' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="issued">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Issued
        </th>
        <td
          mat-cell
          fxHide.lt-md
          *matCellDef="let registration"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <span *ngIf="registration.issued">
            {{ registration.issued | date:'short' }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          mat-sort-header
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Status
        </th>
        <td
          mat-cell
          fxHide.lt-md
          *matCellDef="let registration"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <mat-chip-listbox>
            <mat-chip-option
              [color]="
                registration.status === invitationStatus.NotSent
                  ? ''
                  : registration.status === invitationStatus.Sent
                    ? 'primary'
                    : registration.status === invitationStatus.SendFailure
                      ? 'warn'
                      : 'accent'
              "
              [selected]="registration.status !== invitationStatus.NotSent"
              [matTooltip]="
                registration.status === invitationStatus.SendFailure
                  ? registration.sendFailureDescription
                  : ''
              "
              >{{
                mfa.getInvitationStatusName(registration.status)
              }}</mat-chip-option
            >
          </mat-chip-listbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="additionalUsernames">
        <th
          mat-header-cell
          fxHide.lt-md
          *matHeaderCellDef
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
          i18n
        >
          Additional Usernames
        </th>
        <td
          mat-cell
          fxHide.lt-md
          *matCellDef="let registration"
          [ngClass]="{ 'pad-right': !isRtl, 'pad-left': isRtl }"
        >
          <a (click)="handleAdditionalUsernamesClick(registration, $event)">
            <span>{{ registration.additionalUsernames?.length }} </span>
            <span *ngIf="registration.additionalUsernames?.length > 0">{{
              registration.additionalUsernamesExpanded ? '-' : '+'
            }}</span></a
          >
          <div
            class="indented"
            [@detailExpand]="
              registration.additionalUsernamesExpanded
                ? 'expanded'
                : 'collapsed'
            "
          >
            <div *ngFor="let username of registration.additionalUsernames">
              <span>{{ username }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        fxHide.lt-md
        *matHeaderRowDef="
          [
            'select',
            'icon',
            'username',
            resourceId ? 'email' : 'resourceName',
            'created',
            'issued',
            'status',
            'additionalUsernames'
          ];
          sticky: true
        "
      ></tr>
      <tr
        mat-row
        class="highlightRow"
        *matRowDef="
          let row;
          columns: [
            'select',
            'icon',
            'username',
            resourceId ? 'email' : 'resourceName',
            'created',
            'issued',
            'status',
            'additionalUsernames'
          ]
        "
        (mouseenter)="highlightedRegistration = row"
        (mouseleave)="highlightedRegistration = null"
        (click)="itemClick(row)"
      ></tr>
    </table>
  </div>
  <div *pcpHeaderInject="headerItemLocation.end" fxFlexAlign="end">
    <button
      color="primary"
      mat-raised-button
      [routerLink]="['..', 'registered']"
      fxLayout="row"
      fxLayoutAlign="space-around center"
      fxLayoutGap="15px"
    >
      <span i18n *ngIf="numOfRegisteredUsers > 0">
        {{ numOfRegisteredUsers }} Registered Users
      </span>
      <span i18n *ngIf="numOfRegisteredUsers === 0"> No Registered Users </span>
      <mat-icon class="mat-icon-rtl-mirror"> arrow_forward </mat-icon>
    </button>
  </div>
</div>
